"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var parseStore_1 = require("./parseStore");
var pkg_frontend_vuex_multi_cabins_item_1 = require("pkg-frontend-vuex-multi-cabins-item");
var lodash_1 = require("lodash");
var storeConfig = new pkg_frontend_vuex_multi_cabins_item_1.MultiCabinsItem('cabin1');
var parsedStoreConfig = parseStore_1.parseModule(storeConfig, '');
var mappedGetters = {};
var _loop_1 = function (getterKey) {
    mappedGetters["currentCabin" + getterKey] = function (_state, getters) {
        var activeCabinKey = getters['management/activeCabinKey'];
        return getters["" + activeCabinKey + getterKey];
    };
};
for (var _i = 0, _a = parsedStoreConfig.getters; _i < _a.length; _i++) {
    var getterKey = _a[_i];
    _loop_1(getterKey);
}
var mappedActions = {};
var _loop_2 = function (actionKey) {
    mappedActions["currentCabin" + actionKey] = function (_a, payload) {
        var dispatch = _a.dispatch, getters = _a.getters;
        return __awaiter(this, void 0, void 0, function () {
            var activeCabinKey;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        activeCabinKey = getters['management/activeCabinKey'];
                        return [4 /*yield*/, dispatch("" + activeCabinKey + actionKey, payload)];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
};
for (var _b = 0, _c = parsedStoreConfig.actions; _b < _c.length; _b++) {
    var actionKey = _c[_b];
    _loop_2(actionKey);
}
var mappedMutations = {};
var _loop_3 = function (mutationInfo) {
    mappedMutations["currentCabin" + mutationInfo.mutationKey] = function (state, payload) {
        var activeCabinKey = state.activeCabinKey;
        var subState = lodash_1.get(state, "" + activeCabinKey + mutationInfo.moduleStatePath);
        return mutationInfo.mutation(subState, payload);
    };
};
for (var _d = 0, _e = parsedStoreConfig.mutations; _d < _e.length; _d++) {
    var mutationInfo = _e[_d];
    _loop_3(mutationInfo);
}
exports.default = {
    actions: mappedActions,
    getters: mappedGetters,
    mutations: mappedMutations,
};
//# sourceMappingURL=parsedStore.js.map